import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageBackground } from "@/components/PageBackground";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const parse = () => {
      const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
      const hp = new URLSearchParams(hash);
      const qp = new URLSearchParams(window.location.search);
      return hp.get("session_id") || qp.get("session_id");
    };
    const sessionId = parse();
    if (!sessionId) {
      toast.error("No Google session found");
      navigate("/auth");
      return;
    }
    const role = localStorage.getItem("rm_pending_role") || "tenant";
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role });
        loginWithToken(data.token, data.user);
        toast.success("Signed in with Google");
        navigate(data.user.role === "tenant" ? "/tenant" : data.user.role === "landlord" ? "/landlord" : "/admin");
      } catch {
        toast.error("Google sign-in failed");
        navigate("/auth");
      }
    })();
  }, [navigate, loginWithToken]);

  return <div className="min-h-screen grid place-items-center text-muted-foreground"><PageBackground variant={0} />Signing you in…</div>;
}
